import { atom } from 'recoil'
import { InspectionProjectTypeOverview } from './inspection.types'

interface ProjectTypeInspectionOverviewAtomState {
  items: InspectionProjectTypeOverview[]
}

const projectTypesInspectionOverviewAtom = atom<ProjectTypeInspectionOverviewAtomState>({
  key: 'inspector/projectTypeInspectionOverview',
  default: {
    items: [],
  },
})
export default projectTypesInspectionOverviewAtom
